<script setup>
import {computed, defineProps, defineEmits, ref, watch, onMounted} from "vue";
import {couponConf} from "@/utils/config";
import {ElMessage} from "element-plus";
import axiosApi from "@/utils/axiosApi";
import store from "@/store";
import router from "@/router";

const props = defineProps({
  couponLst: {
    type: Array,
    default: () => {
      return [];
    },
  },
  account: {
    type: Object,
    default: () => {
      return {};
    },
  },
  type: {
    type: Object,
    default: () => {
      return couponConf["pyf-xmair"];
    }
  }
});
const coupon = computed(() => {
  return props.couponLst?.[0]?.data || []
})
const order_from = computed(() => store.state.orderFrom)
const emit = defineEmits(['login'])
const showPayLoading = ref(false)
const product = ref(coupon.value?.[0] || {})
watch(() => props.account, to => {
  if (Object.keys(to).length && Object.keys(product.value).length) {
    showPayLoading.value = true
  }
})
const maxNumber = computed(() => {
  if (Object.keys(props.account).length < 1) return 1;
  return Math.floor(parseFloat(props.account.balance_miles) / parseFloat(coupon.value?.[0]?.score_data?.[props.type.login]?.total))
})
const num = ref(1)
const mobile = ref("")
const loading = ref(false)
onMounted(() => {
  store.commit("getOrderFrom")
})
const payment = () => {
  if (!/^1[3-9]\d{9}$/.test(mobile.value)) {
    return ElMessage.error("手机号填写错误")
  }
  loading.value = true
  let pay_params = JSON.stringify(props.type.login === 'xm_air' ? {
    access_token: props.account.access_token,
    user_id: props.account.user_id
  } : {cust_id: props.account.cust_id})
  new axiosApi({
    method: "coupon/pay",
    encode: "site",
    body: {
      coupon_id: product.value.id,
      uid: props.account.uid,
      pay_type: props.type.login,
      pay_params,
      number: num.value,
      // auto_coupon: "1",
      mobile: mobile.value,
      order_from: order_from.value
    },
    score_type: "xm_air"
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7041") {
      return ElMessage.error(res.message.content)
    }
    if (props.type.login !== 'xm_air')
      router.replace({name: 'success', params: {order: res.data.ordersn}})
    else window.location.replace(res.data.url)
  }, () => {
    loading.value = false
    ElMessage.error("兑换失败")
  })
}
</script>

<template>
  <div class="pyf-coupon-lst">
    <div class="pyf-coupon-header">
      <el-image src="https://images.jifen360.com/pyf/coupon-title.png"/>
    </div>
    <div class="pyf-coupon-its">
      <div class="pyf-coupon-info" v-for="coup in coupon" :key="coup.id">
        <div class="pyf-coupon-left">
          <div class="pyf-coupon-face-value">
            <div class="pyf-coupon-price-unit">￥</div>
            <div class="pyf-coupon-price">{{ coup?.face_value }}</div>
          </div>
          <el-image src="https://images.jifen360.com/pyf/logo.png"/>
        </div>
        <div class="pyf-coupon-right">
          <div class="pyf-coupon-right-content">
            <div style="font-size: .8rem">
              <b>{{ coup.name }}</b>
            </div>
            <div class="pyf-coupon-face-value">
              <el-text class="pyf-coupon-price" type="primary">{{ coup?.score_data?.[type?.login]?.total }}</el-text>
              <el-text class="pyf-coupon-price-unit">{{ coup?.score_data?.[type?.login]?.unit }}</el-text>
            </div>
          </div>
          <div class="pyf-coupon-right-btn">
            <div>
              <el-text type="info" size="small">无门槛·全场通用</el-text>
            </div>
            <div>
              <el-button round type="primary" @click="product = coup,emit('login')"
                         v-if="Object.keys(account).length < 1">立即使用
              </el-button>
              <el-button round type="primary"
                         v-else-if="Object.keys(account).length > 0 && parseInt(account.balance_miles) >= parseInt(coup?.score_data?.[type?.login]?.total)"
                         @click="product = coup,showPayLoading = true">
                立即使用
              </el-button>
              <el-button round type="primary" disabled v-else>可用{{
                  coup?.score_data?.[type?.login]?.unit
                }}不足
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pyf-coupon-recharge">
    <el-image src="https://images.jifen360.com/pyf/recharge.png"/>
    <div class="pyf-recharge-content">
      <div class="pyf-recharge-info" v-for="(recharge,inx) in type.desc" :key="inx">
        <div><b>{{ recharge.title }}</b></div>
        <ol>
          <li v-for="(item,inx) in recharge.content" :key="inx" v-html="item"></li>
        </ol>
      </div>
    </div>
  </div>
  <el-drawer v-model="showPayLoading" direction="btt" class="pay-box" size="440" :show-close="false">
    <template #header>
      <div class="pyf-pay-drawer-header">
        <div class="pyf-pay-header-face-value">
          <el-image :src="type?.product_i"/>
          <div class="face-value">
            <div class="pyf-coupon-price-unit">￥</div>
            <div class="pyf-coupon-price-money">{{ product?.face_value }}</div>
          </div>
        </div>
        <div class="pyf-pay-product">
          <div><b>{{ product?.name }}</b></div>
          <div class="pyf-pay-product-price">
            <el-text type="primary" class="pyf-face-money">{{ product?.score_data?.[type?.login]?.total }}</el-text>
            <el-text type="info" class="pyf-face-unit">{{ product?.score_data?.[type?.login]?.unit }}</el-text>
          </div>
        </div>
      </div>
    </template>
    <el-card shadow="never">
      <div class="pyf-pay-form">
        <div class="pyf-pay-form-item">
          收货手机号
        </div>
        <div class="pyf-pay-form-item-input">
          <el-input v-model="mobile" placeholder="请输入手机号" clearable/>
        </div>
      </div>
    </el-card>
    <el-card shadow="never">
      <div class="pyf-pay-form">
        <div class="pyf-pay-form-item">
          兑换数量
        </div>
        <div class="pyf-pay-form-item">
          <el-input-number v-model="num" :min="1" :max="maxNumber"/>
        </div>
      </div>
    </el-card>
    <el-card shadow="never">
      <div class="pyf-pay-form">
        <div class="pyf-pay-form-item">
          可用{{ product?.score_data?.[type?.login]?.unit }}
        </div>
        <div class="pyf-pay-form-item">
          {{ account?.balance_miles }}
        </div>
      </div>
      <div class="pyf-pay-form">
        <div class="pyf-pay-form-item">
          支付{{ product?.score_data?.[type?.login]?.unit }}
        </div>
        <div class="pyf-pay-form-item">
          {{ product?.score_data?.[type?.login]?.total * num }}
        </div>
      </div>
    </el-card>
    <div class="pyf-pay-btn">
      <el-button type="primary" @click="payment" round :loading="loading">立即兑换</el-button>
    </div>
  </el-drawer>
</template>

<style scoped lang="less">
.pyf-coupon-lst {
  box-sizing: border-box;
  background: #ffffff;
  margin: 10px 15px;
  border-radius: 18px;
  overflow: hidden;

  .pyf-coupon-header {
    .el-image {
      width: 100%;
    }
  }

  .pyf-coupon-its {
    box-sizing: border-box;
    padding: 0 10px;
    margin-top: -10px;

    .pyf-coupon-info {
      background: url("https://images.jifen360.com/pyf/coupon-its.png") no-repeat;
      background-size: 100% 100%;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 10px 10px 10px 0;

      .pyf-coupon-left {
        width: 27%;
        flex-basis: 27%;
        margin-right: 10px;
        text-align: center;

        .pyf-coupon-face-value {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #CF392E;
          font-weight: 600;

          .pyf-coupon-price {
            font-size: 1.55rem;
          }

          .pyf-coupon-price-unit {
            font-size: .8rem;
          }
        }

        .el-image {
          width: 75%;
          margin: auto;
        }
      }

      .pyf-coupon-right {
        display: flex;
        flex-basis: calc(100% - 27% - 10px);
        width: calc(100% - 27% - 10px);
        align-items: center;
        justify-content: space-between;

        .pyf-coupon-face-value {
          margin-top: 10px;

          .pyf-coupon-price {
            font-size: 1.35rem;
          }

          .pyf-coupon-price-unit {
            font-size: .7rem;
          }
        }

        .el-button {
          background: linear-gradient(90deg, #E29477 0%, #DF544B 100%);
          border: none;
          font-size: .8rem;
          margin-top: 8px;
        }
      }
    }
  }
}

.pyf-coupon-recharge {
  margin: 10px 15px;

  .pyf-recharge-content {
    box-sizing: border-box;
    padding: 15px;
    border-radius: 0 0 16px 16px;
    background: #ffffff;
    margin-top: -10px;
    line-height: 1.7;
    font-size: .8rem;

    ol {
      padding-left: 15px;
    }
  }
}

.pay-box {
  .pyf-pay-drawer-header {
    display: flex;
    align-items: center;

    .pyf-pay-header-face-value {
      flex-basis: 100px;
      box-sizing: border-box;
      padding: 8px;
      background: #ffffff;
      border-radius: 8px;
      position: relative;
      width: 100px;
      margin-right: 10px;

      .face-value {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 20px;
        color: #CF392E;
        font-weight: 600;

        .pyf-coupon-price-unit {
          font-size: .6rem;
        }

        .pyf-coupon-price-money {
          font-size: 1.65rem;
        }
      }
    }

    .pyf-pay-product {
      line-height: 1.75;

      .pyf-face-money {
        font-size: 1.75rem;
      }

      .pyf-face-unit {
        font-size: .8rem;
      }
    }
  }

  .el-card {
    --el-card-border-radius: 12px;

    & + .el-card {
      margin-top: 10px;
    }

    .pyf-pay-form {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .pyf-pay-form-item-input {
        flex-basis: 65%;
        width: 65%;
      }

      & + .pyf-pay-form {
        margin-top: 10px;
        padding-top: 10px;
        border-top: var(--el-border);
      }
    }
  }

  .pyf-pay-btn {
    margin-top: 15px;
    text-align: center;

    .el-button {
      width: 90%;
      margin: auto;
    }
  }
}

</style>
